import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { token } from '@ferreri/prever-component-lib';
import { ReactNode } from 'react';

type StandardCarouselProps = {
  children: ReactNode[];
  direction?: 'left' | 'right';
  animationDuration?: number;
  gap?: number;
};

const CARD_GAP = 24;
const ANIMATION_DURATION = 40;

const slideLeft = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const slideRight = keyframes`
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
`;

export const StandardCarousel = ({
  children,
  direction = 'left',
  animationDuration = ANIMATION_DURATION,
  gap = CARD_GAP,
}: StandardCarouselProps) => {
  const duplicatedChildren = [...children, ...children];

  return (
    <CarouselContainer>
      <CarouselWrapper>
        <CarouselTrack
          direction={direction}
          animationDuration={animationDuration}
          gap={gap}
        >
          {duplicatedChildren.map((child, index) => (
            <CardWrapper key={`carousel-item-${index}`}>{child}</CardWrapper>
          ))}
        </CarouselTrack>
        <CarouselTrack
          direction={direction}
          animationDuration={animationDuration}
          gap={gap}
          aria-hidden="true"
        >
          {duplicatedChildren.map((child, index) => (
            <CardWrapper key={`carousel-item-duplicate-${index}`}>
              {child}
            </CardWrapper>
          ))}
        </CarouselTrack>
      </CarouselWrapper>
    </CarouselContainer>
  );
};

const CarouselContainer = styled.div`
  position: relative;
  width: 100vw;
  margin-left: calc(-50vw + 49%);
  overflow: hidden;
  margin-top: ${token.spacing.spacingMedium};
  margin-bottom: ${token.spacing.spacingMedium};
  padding: 12px 0;
`;

const CarouselWrapper = styled.div`
  display: flex;
  width: fit-content;
`;

const CarouselTrack = styled.div<{
  direction: 'left' | 'right';
  animationDuration: number;
  gap: number;
}>`
  display: flex;
  width: fit-content;
  gap: ${(props) => props.gap}px;
  animation: ${(props) => (props.direction === 'left' ? slideLeft : slideRight)}
    ${(props) => props.animationDuration}s linear infinite;
  will-change: transform;
`;

const CardWrapper = styled.div`
  flex-shrink: 0;
`;
